import { fetchPageData } from "../utils/fetch";

export const getDonates = async () => {
  const endpoint = "donates";
  const method = "GET";
  const err = "Failed to fetch donates.";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};

export const updateDonate = async (token, donateId, donateData) => {
  const endpoint = donateId ? `donate/${donateId}` : "donate";
  const err = donateId ? "Editing donate failed." : "Creating donate failed.";
  const method = donateId ? "PUT" : "POST";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    token,
    donateData
  );
  return fetchedData;
};

export const deleteDonate = async (token, donateId) => {
  const endpoint = `donate/${donateId}`;
  const method = "DELETE";
  const err = "Deleting donate failed.";
  const fetchedData = await fetchPageData(endpoint, method, err, token);
  return fetchedData;
};
